import { render, staticRenderFns } from "./StatusMenu.vue?vue&type=template&id=324cdffa&scoped=true&"
import script from "./StatusMenu.vue?vue&type=script&lang=js&"
export * from "./StatusMenu.vue?vue&type=script&lang=js&"
import style0 from "./StatusMenu.vue?vue&type=style&index=0&id=324cdffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324cdffa",
  null
  
)

export default component.exports